import type { RouteRecordRaw } from 'vue-router'
import ClientPortalAuthShell from '@/layouts/ClientPortalAuthShell.vue'
import ContractorLayout from '@/layouts/ContractorLayout.vue'

const authLayout = ClientPortalAuthShell

/** Client portal routes shared by the monolith (host-gated) and detached portal build. */
export const clientPortalRoutes: RouteRecordRaw[] = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'contractor-login' },
  },
  {
    path: '/contractor/login',
    redirect: '/clients/login',
  },
  {
    path: '/clients/login',
    component: authLayout,
    children: [
      {
        name: 'contractor-login',
        path: '',
        component: () => import('@/pages/contractor/ContractorLogin.vue'),
      },
    ],
  },
  {
    path: '/clients/recover-password',
    component: authLayout,
    children: [
      {
        name: 'contractor-recover-password',
        path: '',
        component: () => import('@/pages/contractor/ContractorRecoverPassword.vue'),
      },
    ],
  },
  {
    path: '/clients/recover-password-email',
    component: authLayout,
    children: [
      {
        name: 'contractor-recover-password-email',
        path: '',
        component: () => import('@/pages/contractor/ContractorRecoverPasswordEmail.vue'),
      },
    ],
  },
  {
    path: '/clients/change-password',
    component: authLayout,
    children: [
      {
        name: 'contractor-change-password',
        path: '',
        component: () => import('@/pages/contractor/ContractorChangePasswordPage.vue'),
      },
    ],
  },
  {
    path: '/contractor',
    component: ContractorLayout,
    meta: { requiresContractorAuth: true },
    children: [
      {
        name: 'contractor-dashboard',
        path: 'dashboard',
        component: () => import('@/pages/contractor/ContractorDashboardPage.vue'),
      },
      {
        name: 'contractor-profile',
        path: 'profile',
        redirect: { name: 'contractor-preferences' },
      },
      {
        name: 'contractor-trips',
        path: 'trips',
        redirect: { name: 'contractor-dashboard' },
      },
      {
        name: 'contractor-alarms',
        path: 'alarms',
        redirect: { name: 'contractor-dashboard' },
      },
      {
        name: 'contractor-live-tracker',
        path: 'live-tracker',
        component: () => import('@/pages/client-portal/LiveTrackerPage.vue'),
      },
      {
        name: 'contractor-preferences',
        path: 'preferences',
        component: () => import('@/pages/contractor/ContractorPreferencesPage.vue'),
      },
      {
        name: 'contractor-vehicles',
        path: 'vehicles',
        component: () => import('@/pages/contractor/ContractorVehiclesPage.vue'),
      },
      {
        name: 'contractor-drivers',
        path: 'drivers',
        component: () => import('@/pages/contractor/ContractorDriversPage.vue'),
      },
      {
        name: 'contractor-billing',
        path: 'billing',
        redirect: { name: 'contractor-dashboard' },
      },
      {
        name: 'contractor-team',
        path: 'team',
        component: () => import('@/pages/contractor/ContractorTeamPage.vue'),
      },
      {
        name: 'contractor-reports',
        path: 'reports',
        component: () => import('@/pages/contractor/ClientReportsPage.vue'),
      },
      {
        name: 'contractor-odometer-reports',
        path: 'reports/odometer',
        component: () => import('@/pages/contractor/ClientOdometerReportsPage.vue'),
      },
      {
        name: 'contractor-charging-reports',
        path: 'reports/charging',
        component: () => import('@/pages/contractor/ClientChargingReportsPage.vue'),
      },
      {
        path: '',
        redirect: { name: 'contractor-dashboard' },
      },
    ],
  },
]
